export const GET_REGIONS = 'GET_REGIONS'
export const GET_REGIONS_SUCCESS = 'GET_REGIONS_SUCCESS'
export const GET_REGIONS_FAILED = 'GET_REGIONS_FAILED'

export const SET_REGION = 'SET_REGION'

export const ADDRESS_SEARCH_AUTOCOMPLETE = 'ADDRESS_SEARCH_AUTOCOMPLETE'
export const ADDRESS_SEARCH_AUTOCOMPLETE_SUCCESS = 'ADDRESS_SEARCH_AUTOCOMPLETE_SUCCESS'
export const ADDRESS_SEARCH_AUTOCOMPLETE_FAILED = 'ADDRESS_SEARCH_AUTOCOMPLETE_FAILED'

export const ADDRESS_SEARCH_RESOLVE_AUTOCOMPLETE = 'ADDRESS_SEARCH_RESOLVE_AUTOCOMPLETE'
export const ADDRESS_SEARCH_RESOLVE_AUTOCOMPLETE_SUCCESS = 'ADDRESS_SEARCH_RESOLVE_AUTOCOMPLETE_SUCCESS'
export const ADDRESS_SEARCH_RESOLVE_AUTOCOMPLETE_FAILED = 'ADDRESS_SEARCH_RESOLVE_AUTOCOMPLETE_FAILED'

export const ADDRESS_SEARCH_ID_AUTOCOMPLETE = 'ADDRESS_SEARCH_ID_AUTOCOMPLETE'
export const ADDRESS_SEARCH_ID_AUTOCOMPLETE_SUCCESS = 'ADDRESS_SEARCH_ID_AUTOCOMPLETE_SUCCES'
export const ADDRESS_SEARCH_ID_AUTOCOMPLETE_FAILED = 'ADDRESS_SEARCH_ID_AUTOCOMPLETE_FAILED'
